import * as React from 'react';

const UsersIcon = ({
  fill = 'currentColor',
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg width="33" height="33" viewBox="0 0 33 33" fill="none" {...props}>
    <path
      d="M5.90479 11.8511C5.90479 13.2125 6.44561 14.5182 7.40829 15.4808C8.37097 16.4435 9.67664 16.9843 11.0381 16.9843C12.3995 16.9843 13.7052 16.4435 14.6679 15.4808C15.6305 14.5182 16.1714 13.2125 16.1714 11.8511C16.1714 10.4896 15.6305 9.18396 14.6679 8.22128C13.7052 7.2586 12.3995 6.71777 11.0381 6.71777C9.67664 6.71777 8.37097 7.2586 7.40829 8.22128C6.44561 9.18396 5.90479 10.4896 5.90479 11.8511Z"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.6377 27.2505C2.6377 25.0227 3.52269 22.8862 5.09798 21.3109C6.67327 19.7356 8.80982 18.8506 11.0376 18.8506C13.2654 18.8506 15.402 19.7356 16.9773 21.3109C18.5526 22.8862 19.4375 25.0227 19.4375 27.2505"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.5649 14.6511C19.5649 15.765 20.0074 16.8333 20.7951 17.621C21.5827 18.4086 22.651 18.8511 23.7649 18.8511C24.8788 18.8511 25.9471 18.4086 26.7347 17.621C27.5224 16.8333 27.9649 15.765 27.9649 14.6511C27.9649 13.5372 27.5224 12.469 26.7347 11.6813C25.9471 10.8937 24.8788 10.4512 23.7649 10.4512C22.651 10.4512 21.5827 10.8937 20.7951 11.6813C20.0074 12.469 19.5649 13.5372 19.5649 14.6511Z"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.3833 20.8022C22.4225 20.4192 23.5389 20.2929 24.6374 20.4339C25.7359 20.575 26.7841 20.9793 27.6928 21.6125C28.6015 22.2457 29.3438 23.089 29.8566 24.0707C30.3694 25.0523 30.6375 26.1433 30.6382 27.2509"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const MemoUsersIcon = React.memo(UsersIcon);
export default MemoUsersIcon;
